<template>
  <v-layout row justify-space-between>

    <v-flex xs4>
      <ul class="info-listing">
        <li><span>Status:</span> {{ employee.status }}</li>
        <li><span>Start Date:</span> {{ employee.start_date | moment("MM/DD/YYYY")}}</li>
        <li><span>Promo Date:</span> {{ recentPromoDate | moment("MM/DD/YYYY") }}</li>
      </ul>
      <v-divider></v-divider>
      <ul class="info-listing">
        <li>
          <span>Hours this week: </span>
          <span v-if="statsLoading">loading...</span>
          <span v-else>
            {{ workHistoryStats.thisWeekHours }}
          </span>
        </li>

        <li>
          <span>Avg weekly hours (ytd): </span>
          <span v-if="statsLoading">loading...</span>
          <span v-else>
            {{ workHistoryStats.averageWeekHoursYTD }}
          </span>
        </li>

        <li>
          <span>Avg weekly hours (l12): </span>
          <span v-if="statsLoading">loading...</span>
          <span v-else>
            {{ workHistoryStats.averageWeekHoursL12 }}
          </span>
        </li>
      </ul>
      <v-divider></v-divider>
      <ul class="info-listing todo">
        TODO:
        <li><span>client rating (ytd):</span> 85</li>
        <li><span>client rating (l12):</span> 87</li>
      </ul>
      <v-divider></v-divider>
      <ul class="info-listing todo">
        TODO:
        <li><span>clock-in diff (ytd):</span> -4.2 min</li>
        <li><span>clock-in diff (l12):</span> +2.1 min</li>
        <li><span>absentee rate:</span> 10%</li>
        <li><span>pto:</span> 30 hours</li>
      </ul>
      <v-divider></v-divider>
    </v-flex>

    <v-flex xs4 mx-4>
      <v-sheet color="grey lighten-3">
        <v-layout row pa-2>
          <v-flex class="text-xs-center title">
            <ul class="info-listing my-4">
              <li class="my-2">
                <span>Shift Count</span>
                <span v-if="statsLoading">Loading...</span>
                <span v-else>{{ workHistoryStats.shiftCount }}</span>
              </li>
              <li class="my-2"><span>Base rate</span> ${{ employee.base_rate }}</li>
            </ul>
            <v-divider></v-divider>
            <ul class="info-listing my-4">
              <li class="my-2"><span>phone number:</span> {{ employee.phone }}</li>
              <li class="my-2">{{ employee.sms_opt_out ? 'Opts out of SMS' : 'Receives SMS' }}</li>
              <li class="my-2"><span>email:</span> {{ employee.email }}</li>
              <li class="my-2"><span>Manager:</span> {{ employee.manager_name }}</li>
            </ul>
          </v-flex>
        </v-layout>
      </v-sheet>
    </v-flex>

    <v-flex xs4>
      <div class="mb-2">
        <h2 class="all-caps">dosimeter badge</h2>

        <span><router-link :to="{ name: 'employee/certifications', params: { employeeId: employee.id } }">Last upload: {{ profile.last_dosimetry_upload_date | moment("MM/DD/YYYY") }}</router-link></span>
        <v-btn v-if="false" small disabled>
          <v-icon left>
            add
          </v-icon>
          Request New Reading
        </v-btn>
      </div>

      <v-divider class="mb-2"></v-divider>

      <h2 class="all-caps">certifications</h2>
        <div v-if="employeeCertifications.length > 0 || employeeInsurances > 0">
          <ul class="unstyled">
            <li class="body-2" v-for="cert in employeeCertifications">
              <router-link :to="{ name: 'employee/certifications', params: { employeeId: employee.id } }">{{ cert.certification_type }} | Exp {{ cert.expiration_date }}</router-link>
            </li>
            <li class="body-2" v-for="ins in employeeInsurances">
              <router-link :to="{ name: 'employee/certifications', params: { employeeId: employee.id } }">{{ ins.certification_type }} | Exp {{ ins.expiration_date }}</router-link>
            </li>
          </ul>
        </div>
        <div v-else class="subtle">
          None
        </div>

    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Info from '@/components/hr/info.vue'

export default {
  data() {
    return {
      profile: {},
      statsLoading: false,
    }
  },
  created: function () {
    this.statsLoading = true;
    this.$store.dispatch('hr/getWorkHistory',
      {
        user_id: this.employee.id,
      },
    ).then((p) => {
      this.workHistoryStats = p.stats
      this.queryTotal = p.totalItems
    })
    .finally(() => {
      this.statsLoading = false;
    })
    this.$store.dispatch('profiles/getUserID', this.employee.id).then((p) => {
      this.profile = p
    })
  },
  components: {
    Info
  },
  props: [
    'employee'
  ],
  computed: {
    recentPromoDate: function() {
      return this.$store.getters['employees/mostRecentPromotion']
    },
    ...mapGetters('employees', [
      'employeeCertifications',
      'employeeInsurances',
    ]),
    ...mapState('hr', [
      'workHistoryStats',
    ]),
  },
}
</script>
